<template>

    <section id="team">

        <!-- HEADER -->
        <div class="topbanner">
            <div class="headline">
                <h1 v-bind:class="{ 'blur': blurheadline}">Translation Services</h1>
                <p class="subhead orange mb-1" v-bind:class="{ 'blur': blurheadline}">Where language meets business.</p>
                <p class="subhead" v-bind:class="{ 'blur': blurheadline}">Branton Translation delivers your brand communications 
in a multitude of languages to maximize your reach</p>


            </div>

          <figcaption class="page-header-description topbottom">TRANSLATIONS</figcaption>

            <div id="topheader">
                <b-carousel id="carousel" v-model="slide" :interval="4000" :fade='true' no-indicators>
                    <b-carousel-slide class="team4"></b-carousel-slide>
                </b-carousel>
            </div>
        </div>


        <!-- POOL SHAKERS -->
        <b-row class="filler justify-content-center">
            <b-col cols="11" sm="10">
                <b-row class="page-description">
                    <b-col data-aos="fade-up" cols='12'>
                        <b-img fluid :src="require(`../assets/images/b-language.png`)" alt="Language Tool Icon"></b-img>
                        <h3 class="mt-4">Language is a Powerful Tool</h3>
                    </b-col>
                    <b-row class="description-details">
                        <b-col data-aos="fade-right" col cols="12">
                            <p class="larger">It’s not just about what you say, but how you say it. Let us take care of the linguistic aspect of your project, from translations to quality assurance, to tone of voice and your brand identity. Our 35 years of reliable expertise is reflected in the quality of our services, just ask our clients!</p>
                        </b-col>
                    </b-row>
                </b-row>
            </b-col>
        </b-row>



        <b-row class="filler orange justify-content-center">
            <b-col cols="11" sm="10">
                <b-row class="page-description">
                    <b-row class="description-details dark">
                        <b-col data-aos="fade-right" col cols="12" md="6">
                            <h3 class="mt-4 mb-4">Translation Solutions </h3>
                            <p>Our team of skilled and diversified translators delivers top-quality translations in an array of different languages. Our experience with highly technical content also makes us the best choice for technical translations.</p>
                            <p>We take the time to discuss your vision, the challenges you’ve faced and the final message you want to deliver to your audience, all while providing you with a cost and time efficient solution.</p>
                        </b-col>
                        <b-col data-aos="fade-left" col cols="12" md="6">
                            <h3 class="mt-4 mb-4">Quality & Efficiency</h3>
                            <p>With the use of Computer-assisted translation (CAT) tools, we can help speed up the translation process while reducing your costs.</p>
                            <p>Our expertise with these tools allows us to translate your content precisely and efficiently. </p>
                        </b-col>
                        <b-col data-aos="fade-right" col cols="12" md="6">
                            <h3 class="mt-4 mb-4">Localization</h3>
                            <p>Our design and translation teams can help you localize global assets to ensure they are compliant for your target audience, anywhere around the world. This means we make sure your document is legally compliant for publication, adheres to brand compliance guidelines, and is void of any grammatical or language errors. </p>
                        </b-col>
                        <b-col data-aos="fade-left" col cols="12" md="6">
                            <h3 class="mt-4 mb-4">Terminology Management</h3>
                            <p>Terminology Management is one of the most important aspects of the translation process. We are committed to adhering to your brand identity by using style guides containing the terminology that is unique to your business. The use of these style guides also helps us expedite any future translation projects for your brand while allowing us to remain consistent with brand messaging, identity, and the quality of all your assets.</p>
                        </b-col>
                    </b-row>
                </b-row>
            </b-col>
        </b-row>

        <b-row class="filler justify-content-center">
            <b-col cols="11" sm="10">
                <b-row class="page-description">
                    <b-col data-aos="fade-up" cols='12'>
                        <b-img fluid :src="require(`../assets/images/b-capabilities.png`)" alt="Capabilities"></b-img>
                        <h3>Wide Range of Project Capabilities </h3>
                        <p class="larger">Although every project is unique, we have the experience and expertise to handle a variety of project types, including but not limited to:</p>
                    </b-col>
                    <b-row class="description-details bulletcolumns">
                        <b-col data-aos="fade-right" col cols="12" md="6">
                            <ul>
                                <li>Brochures</li>
                                <li>Catalogues</li>
                                <li>Sales assets</li>
                                <li>Technical data sheets</li>
                                <li>Reports</li>
                                <li>Medical and financial documents</li>
                                <li>Human and Public Relations</li>
                                <li>Websites and online content</li>
                                <li>Advertising</li>
                                <li>Video content</li>
                                </ul>
                        </b-col>
                        <b-col data-aos="fade-left" col cols="12" md="6">
                            <ul>
                                <li>Presentations</li>
                                <li>Packaging</li>
                                <li>Displays</li>
                                <li>Communications</li>
                                <li>Press releases</li>
                                <li>Announcements</li>
                                <li>Product literature</li>
                                <li>Policies</li>
                                <li>Legal documents</li>
                                <li>Manuals</li>
                                </ul>
                        </b-col>
                    </b-row>
                </b-row>
            </b-col>
        </b-row>


        <b-row class="filler orange sidecar justify-content-center">
                    <b-col class="sectiona" data-aos="fade-left" data-aos-offset="500" col lg="6" cols="12"></b-col>
                    <b-col data-aos="fade-right" data-aos-offset="500" col lg="6" cols="12" class="copy dark">
                        <h2>Desktop Publishing</h2>
                        <p>We pride ourselves on delivering the highest quality creative content. This means that, thanks to our team of skilled designers, we offer an all-in-one solution for your translation projects. Our desktop publishing service ensures that the quality of your assets remain top notch throughout the process, from start to finish – delivering a perfectly arranged final copy of your translated content. A single point of contact for your entire project means an efficient and simple, cost-effective solution.</p>
                        <h2>Quality Assurance</h2>
                        <p>Typos are not an option. Our quality assurance service includes reviewing, proofreading, and editing of existing documents to ensure all types of errors are caught and corrected before your clients do. We also look for inconsistencies throughout your document in terms of tone of voice, brand messaging, terminology, and we ensure that the meaning of the source language is retained in the target language.</p>
                    </b-col>
                  
                </b-row>


                <b-row class="filler white sidecar justify-content-center">
                
                    <b-col  data-aos="fade-right" data-aos-offset="500" col lg="6" cols="12" class="copy dark">
                        <h2 class="mb-5">Industries in Which We Specialize</h2>
                    
                        <b-row>
                            <b-col>
                                <ul>
                        <li>Automotive</li>
                        <li>Consumer Markets</li>
                        <li>Electronics</li>
                        <li>Finance</li>
                        <li>Human Resources/Brand</li>
                        <li>Industrial Manufacturing</li>
                        <li>Energy</li>
                        </ul>
                            </b-col>
        <b-col>
            <ul>
                     <li>Legal Services</li>
                        <li>Life Sciences</li>
                        <li>Medical Care</li>
                        <li>Oral Care</li>
                        <li>Personal Safety</li>
                        <li>Technology</li>
                        <li>Transportation</li>
                        </ul>
                            </b-col>

                        </b-row>
                      

                    </b-col>
                    <b-col class="sectionb"   data-aos="fade-left" data-aos-offset="500" col lg="6" cols="12"></b-col>
                
                </b-row>

    </section>

</template>


<script>
    // import TeamListing from '@/views/supports/TeamListing';

    import AOS from 'aos';
    import 'aos/dist/aos.css';
    export default {
        metaInfo: {
            titleTemplate: 'Translation Services at Branton — A Creative Design Agency',
            meta: [{
                name: "Translations Services",
                content: "Where language meets business. Branton Translation delivers your brand communications in a multitude of languages to maximize your reach."
            }]
        },
        components: {
  
        },
        props: ['Team'],
        data() {
            return {
                scrolled: false,
                blurheadline: false,
                slide: 0,
                sliding: null,
                lightBoxActive: false,
                lightboxFeed: '',

            }
        },
        mounted() {
             AOS.init();

   this.$gtag.pageview({
        page_path: '/team',
      })

            window.addEventListener("load", function() {
                AOS.refresh();
            });
        },
        methods: {
      
            handleScroll() {
                if (window.scrollY > 400) {
                    this.blurheadline = true;
                } else {
                    this.blurheadline = false;
                }
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        }

    }
</script>


<style lang="scss">
    @import '@/assets/css/translations.scss';
</style>